import * as React from 'react';

export const UserIdContext = React.createContext<any>({
    userIdData: {},
    updateUserId: (userIdData: any) => { },
});